import { IJsonSerializable, IOpData, IOpChangeState } from "../util/interfaces"
import { Enums } from "../common"
import { OpDataType } from "./op-data-type"

export class OpArticleData implements IJsonSerializable, IOpChangeState, IOpData {

    //#region Properties

    public idArticleData: number
    public idArticle: number
    public idDataType: number
    public indexNbr: number
    public value: any

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    //#endregion


    //#region NavigationProperties

    public dataType: OpDataType

    //#endregion


    //#region IOpChangeState Implementatnion

    public opState: Enums.OpChangeState

    //#endregion


    //#region IOpData Implementatnion

    public get idData() {
        return this.idArticleData
    }

    public set idData(idData: number) {
        this.idArticleData = idData
    }

    public get indexNBR() {
        return this.indexNbr
    }

    public set indexNBR(indexNBR: number) {
        this.indexNbr = indexNBR
    }

    //#endregion


    //#region toString

    public toString() {
        return "ArticleData [" + this.idData + "]"
    }

    //#endregion


    //#region IJsonSerializable Implementation

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.idData = opObj.I
            this.idDataType = opObj.E
            this.indexNBR = opObj.N
            this.value = opObj.D
            this.opState = opObj.V

            if (opObj._DataType != null) {
                this.dataType = new OpDataType(opObj._DataType)
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            IdData: this.idData,
            IdDataType: this.idDataType,
            IndexNBR: this.indexNBR,
            Value: this.value,
            OpState: this.opState,
        }
    }

    //#endregion


    //#region fromIOpData

    public static fromIOpData(data: IOpData): OpArticleData {
        const newData: OpArticleData = new OpArticleData(null)

        newData.idArticleData = data.idData
        newData.idDataType = data.idDataType
        newData.indexNbr = data.indexNBR
        newData.value = data.value
        newData.opState = data.opState

        return newData
    }

    //#endregion
}